import { ref, getCurrentInstance, nextTick } from 'vue';
// Importujemy wspólne komponenty i moduły z main.js
import { sharedComponents, sharedElementPlusComponents } from '../utils/vue.js';
import { useCommonLogic } from '../utils/commonVue.js';
export default {
    components: {
        ...sharedComponents,
        ...sharedElementPlusComponents
    },
    setup () {
        const instance = getCurrentInstance();
        const commonLogic = useCommonLogic();
        const searchFilter = ref([]);
        const queryString = window.location.search;
        const urlParams = new URLSearchParams(queryString);
        if (urlParams.size) {
            const filter = urlParams.has('filter') ? urlParams.get('filter') : null;
            const search = urlParams.has('search') ? urlParams.get('search') : null;
            if (filter) {
                searchFilter.value = filter.split(',').map(Number);
            }
            if (!filter && !search) {
                const newUrl = window.location.pathname;
                window.history.replaceState(null, '', newUrl);
            } else {
                nextTick(()=>{
                    instance.proxy.ScrollTo('specialists');
                });
            }
        }
        return {
            ...commonLogic,
            searchFilter
        };
    }
};
